// src/components/ProductDetailsU.js
import React from 'react';
import { FaAndroid, FaMicrochip, FaPlug, FaBarcode, FaNetworkWired, FaLinux } from 'react-icons/fa';
import { GiMicrochip, GiClothes, GiBookshelf } from 'react-icons/gi';
import { MdLibraryBooks, MdOutlineInventory } from 'react-icons/md';
import './ProductDetails.css';
import U300 from '../resorcesfiles/ideak/u300.jpg'; // Use your provided image path
import Mainmastet from '../masterpage/Mainmastet';



const ProductDetailsU = () => {
  return (
    <Mainmastet content={<>
    <div className="product-details-container">
      <h1>Android 11 OS, Multiple Interfaces, More Powerful UHF RFID Performance</h1>
      <div className="product-content">
        <div className="product-details">
          <div className="features">
            <div className="feature-item">
              <GiMicrochip size={32} />
              <p>UHF RFID (Impinj E710/R2000 Chip)</p>
            </div>
            <div className="feature-item">
              <FaPlug size={32} />
              <p>DC / POE / POE+ Power Supply</p>
            </div>
            <div className="feature-item">
              <FaNetworkWired size={32} />
              <p>Supports RS232/RJ45/HDMI</p>
            </div>
            <div className="feature-item">
              <FaBarcode size={32} />
              <p>Optional 4-Port or 8-Port</p>
            </div>
            <div className="feature-item">
              <FaAndroid size={32} />
              <p>Android 11</p>
            </div>
            <div className="feature-item">
              <FaLinux size={32} />
              <p>Linux OS (In Development)</p>
            </div>
          </div>
        </div>
        <div className="product-image-container">
          <img src={U300} alt="Product U300" className="product-image" />
        </div>
      </div>



      
      <div className="applications-container">
        <h2>Applications</h2>
        <div className="features">
          <div className="feature-item">
            <GiClothes size={32} />
            <p>Jewelry Monitoring</p>
          </div>
          <div className="feature-item">
            <FaBarcode size={32} />
            <p>Vending Machines</p>
          </div>
          <div className="feature-item">
            <GiMicrochip size={32} />
            <p>Intelligent Manufacture</p>
          </div>
          <div className="feature-item">
            <MdLibraryBooks size={32} />
            <p>Archives and Library Management</p>
          </div>
          <div className="feature-item">
            <MdOutlineInventory size={32} />
            <p>Inventory Management</p>
          </div>
          <div className="feature-item">
            <GiClothes size={32} />
            <p>Clothing and Footwear Retail</p>
          </div>
        </div>
      </div>
    </div>
    
    
    </>} />
  );
};

export default ProductDetailsU;
